/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import VueCookie from 'vue-cookie'
import { GitCommitIcon } from 'vue-feather-icons'

const getters = {

	// COMPONENT
  // vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  isLogin (state) {
    return state.token || VueCookie.get('token')
  },
  
  getUserInfo (state) {
    
    let userInfo = state.userInfo

    if (userInfo === null) {
      const strUserInfo = VueCookie.get('userInfo')
      userInfo = JSON.parse(strUserInfo)
    }
    return userInfo
  },

  getToken (state) {
    return state.token || VueCookie.get('token')
  },

  getContentsParams (state) {
    return state.contentsParams
  },

  getStudentParams (state) {
    return state.studentParams
  },

  getTeacherParams (state) {
    return state.teacherParams
  },

  getOrderSheetParams (state) {
    return state.orderSheetParams
  },
  getInstituteParams (state) {
    return state.instituteParams
  },
  getCommonMemberParams (state) {
    return state.commonMemberParams
  }
}

export default getters
